import { render, staticRenderFns } from "./XImg.vue?vue&type=template&id=2decf1d7&"
import script from "./XImg.vue?vue&type=script&lang=js&"
export * from "./XImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports